import {Component, computed, effect, inject, input, output, signal} from '@angular/core';
import {PartyType, TodoCompletion, TodoState, TodoSummary} from '../../../../../api';
import {DueDateFormatPipe} from '../../pipes/due-date-format.pipe';
import {DueDateClassPipe} from '../../pipes/due-date-class.pipe';
import {TodoPriorityIndicator} from '../todo-priority/todo-priority-indicator.component';
import {PartyAvatar} from '../../../../components/avatar/party-avatar.component';
import {TodoKanbanCardSubTodo} from '../todo-kanban-card-sub-todo/todo-kanban-card-sub-todo';
import {SubTodoExpander} from '../sub-todo-expander/sub-todo-expander';
import {Tooltip} from 'primeng/tooltip';
import {DueDateFullPipe} from '../../pipes/due-date-full.pipe';
import {Router, RouterLink} from '@angular/router';
import {Checkbox} from 'primeng/checkbox';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {ElciaIcon} from '../../../../components/icon/icon';
import {DurationInDaysPipe} from '../../pipes/duration-in-days-pipe';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'elcia-todo-kanban-card',
  imports: [DueDateFormatPipe, DueDateClassPipe, DueDateFullPipe, TranslatePipe, TodoPriorityIndicator, PartyAvatar, TodoKanbanCardSubTodo, SubTodoExpander, Tooltip, RouterLink, Checkbox, ReactiveFormsModule, ElciaIcon, DurationInDaysPipe],
  templateUrl: './todo-kanban-card.html',
  styleUrl: './todo-kanban-card.scss',
})
export class TodoKanbanCard {
  router = inject(Router);
  todo = input.required<TodoSummary>();
  highlighted = input(false);
  highlightChildId = input<number | null>(null);
  onEdit = output<TodoSummary>();
  onCompletionChange = output<TodoSummary>();
  onChildCompletionChange = output<TodoSummary>();
  expanded = signal(false);
  completionControl = new FormControl<boolean>(false, {nonNullable: true});
  childrenDone = computed(() => this.todo()?.children?.filter(c => c.completion === TodoCompletion.DONE)?.length ?? 0);
  concernRouterLink = computed(() => {
    const concern = this.todo().concern;
    if (!concern) return null;
    return concern.type === PartyType.Company
      ? ['/directory/form', concern.id]
      : ['/directory/form', 'contact', concern.id];
  });

  constructor() {
    effect(() => {
      const isDone = this.todo().completion === TodoCompletion.DONE;
      if (this.completionControl.value !== isDone) {
        this.completionControl.setValue(isDone, {emitEvent: false});
      }
    });
    effect(() => {
      const id = this.highlightChildId();
      if (id && this.todo().children?.some(c => c.id === id)) {
        this.expanded.set(true);
      }
    });
  }

  editTodo() {
    this.onEdit.emit(this.todo())
  }

  toggleCompletion() {
    this.onCompletionChange.emit(this.todo());
  }

  protected readonly TodoState = TodoState;
  protected readonly TodoCompletion = TodoCompletion;
}
